module.exports = __webpack_public_path__ + "img/cinema.3f3f496c.png";